import React, { ReactNode } from "react";

import { Col, Row } from "antd/es/grid";
import { useIntl } from "react-intl";

import { Button, Modal } from "@mapmycustomers/ui";

import layout from "@app/styles/layout";

import styles from "./BaseModal.module.scss";

interface Props {
  applyDisabled?: boolean;
  applyLoading?: boolean;
  children: ReactNode;
  onApply?: () => void;
  onHide?: () => void;
  title: ReactNode;
}

const BaseModal: React.FC<Props> = ({
  applyDisabled,
  applyLoading,
  children,
  onApply,
  onHide,
  title,
}) => {
  const intl = useIntl();

  return (
    <Modal
      className={styles.panel}
      footer={null}
      onCancel={onHide}
      title={title ? <div className={styles.title}>{title}</div> : null}
      visible
    >
      <div className={styles.content}>{children}</div>
      <Row gutter={layout.spacerS} justify="end">
        <Col>
          <Button onClick={onHide}>
            {intl.formatMessage({
              id: "view.selectBar.addRemove.routes.cancel",
              defaultMessage: "Cancel",
              description: "Cancel button label",
            })}
          </Button>
        </Col>

        <Col>
          <Button disabled={applyDisabled} loading={applyLoading} onClick={onApply} type="primary">
            {intl.formatMessage({
              id: "view.selectBar.addRemove.apply",
              defaultMessage: "Apply",
              description: "Apply button label",
            })}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default BaseModal;
